import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-honey-50 pt-24">
      <div className="text-center px-4">
        <h1 className="font-cormorant-garamond text-8xl font-bold text-honey-600 mb-4">404</h1>
        <h2 className="font-cormorant-garamond text-3xl font-semibold text-gray-800 mb-4">
          Страница не найдена
        </h2>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          К сожалению, запрашиваемая страница не существует. Возможно, она была перемещена или удалена.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-honey-500 hover:bg-honey-600 text-black px-6 py-3 rounded-full font-medium transition-all"
        >
          <Home size={18} />
          Вернуться на главную
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
